import React, { Component } from 'react';
class OurStory extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
        <div className="container-xxl mt-5 inner_con_grey" id="story">
            <div className="container inner_con">
            <div className="row g-4">
              <h1 className="text-start mt-5 wow fadeInUp title_view" data-wow-delay="0.1s">Our Story</h1>
                <div className="row g-4">
                    <div className="col-lg-12 wow fadeIn margin_top_zero" data-wow-delay="0.5s">
                        <p className="mb-4"><b>BYLAWS Legal LLP (BYLAWS)</b> was founded with a clear and deliberate vision to build a law firm
                        that delivers the service quality, discipline and credibility of a top-tier legal institution, while
                        remaining accessible and responsive to the needs of emerging, growth-stage and newly scaling
                        businesses operating in complex regulatory environments.</p>
                        <p className="mb-4">The firm is led by its Managing Partner, <i>Mr. Prem Choudhary</i>, whose professional experience
                        spans legal advisory, regulatory compliance, transactional support and dispute resolution across
                        diverse sectors. Drawing from extensive exposure to corporate, financial and regulatory
                        frameworks, the firm was conceptualised to bridge a critical gap in the legal services ecosystem,
                        where growing businesses require sophisticated legal and regulatory support, but often lack
                        access to structured, institution-grade legal counsel.</p>
                        <p className="mb-4">From its inception, BYLAWS has been built on the principle that legal excellence is defined not
                        only by knowledge of law, but by quality of execution, regulatory sensitivity and consistency of
                        service delivery. The firm was designed to operate with the same internal discipline, governance
                        standards and professional rigour expected of established top-tier law firms, while maintaining
                        agility and practical engagement with clients navigating growth, compliance and operational scale.</p>
                        <p className="mb-4">Under the leadership of <i>Mr. Prem Choudhary</i>, BYLAWS  looks to evolve into a practice that
                        integrates legal support, regulatory advisory, strategic corporate guidance, transactional execution
                        and litigation services under a unified institutional framework. The Managing Partner remains
                        closely involved in the firm’s key engagements, ensuring senior-level oversight, adherence to
                        professional standards and alignment with the firm’s core values.</p>
                        <p className="mb-5">BYLAWS continues to grow with a focus on serving regulated entities, corporates, financial
                        institutions, professionals and entrepreneurs who seek dependable legal counsel that is
                        structured, regulator-aligned and execution-oriented. The firm’s journey reflects a sustained
                        commitment to building a legal institution that prioritises service quality, ethical practice and long-
                        term client trust.</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    );
  }
}

export default OurStory;
